enum FormTheme {
  Light = 'light',
  Dark = 'dark',
}

export default FormTheme;
